
// This mixin is used to validate translatable fields

export default {
  methods: {
    mixIsValidTranslations (translations) {
      for (const key in translations) {
        if (translations[key]) {
          if (translations[key]?.isEnabled) {
            return true
          }
        }
      }
      return false
    }
  }
}
